const screenSize = () => {
  if (window.matchMedia("(max-width: 768px)").matches) return "mobile";

  return "desktop";
};

export default screenSize;
